module.exports = __webpack_public_path__ + "static/img/fish28.812a593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish28.png
// module id = xjZz
// module chunks = 0